export default function driverAccordion() {
  const btns = document.querySelectorAll(".js-accordion-item-open");

  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const parent = btn.parentElement;
      parent.classList.toggle("open");
    });
  });
}
